import strpad from 'strpad'
import moment from '../../../node_modules/moment'

export const SERVER_DATE_FORMAT = 'YYYYMMDD'
export const CONFIG_DATE_FORMAT = 'YYYY-MM-DD'
export const CONFIG_DATE_FORMAT_2 = 'DD/MM/YYYY'

export const simpleDateNumber = () => {
  return +(moment().format(SERVER_DATE_FORMAT))
}

export const simpleTimeFormatter = function (h, m) {
  return strpad.left(h, 2, '0') + ':' + strpad.left(m, 2, '0')
}

export const simpleTimeFormatterObj = function (obj) {
  return simpleTimeFormatter(obj.h, obj.m)
}

export const middleDateFormatter = function (date) {
  return moment(date).locale('it').format('DD MMM YYYY')
}

export const longDateFormatter = function (date) {
  return moment(date).locale('it').format('ddd, DD MMM YYYY')
}

export const smallDateFormatter = function (date) {
  return moment(date).locale('it').format('DD/MM/YYYY')
}

export const smallerDateFormatter = function (date) {
  return moment(date).locale('it').format('DD/MM')
}

export const serverDateFormatter = function (date) {
  return moment(date).locale('it').format('YYYYMMDD')
}

export const getDayExtended = function (date) {
  return moment(date).locale('it').format('ddd')
}

export const getDay = function (date) {
  return moment(date).locale('it').format('DD')
}

export const getMonth = function (date) {
  return moment(date).locale('it').format('MMM')
}

export const getYear = function (date) {
  return moment(date).locale('it').format('YYYY')
}

export const toDateFromServer = function (serverDate) {
  const year = 2000 + serverDate[0]
  const month = serverDate[1]
  const day = serverDate[2]
  return new Date(year, month, day)
}

export const normalizePeriod = function (period) {
  if (period.start instanceof Date) return period
  return {start: toDateFromServer(period.start.date), end: toDateFromServer(period.end.date)}
}

export const formatMoney = function (amount, decimalCount = 0, decimal = ',', thousands = '.') {
  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount
  const negativeSign = amount < 0 ? '-' : ''
  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
  let j = (i.length > 3) ? i.length % 3 : 0
  return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
}

export const formatShortPeriods = function (periods) {
  let str = ''
  periods.forEach((item, index) => {
    str += moment(item.start).locale('it').format('DD/MM')
    str += '-'
    str += moment(item.end).locale('it').format('DD/MM')
    if (index !== periods.length - 1) str += ', '
  })
  return str
}



// WEBPACK FOOTER //
// ./src/front/utils/formatter.js